import Breadcrumbs from "../../../components/breadcrumbs";
import GreetingOccasionCategoryCreateForm from "./ui/greeting-occasion-category-create-form";

export default function GreetingOccasionCategoryCreatePage(){
     return (
            <main className="max-w-3xl ">
              <Breadcrumbs
                breadcrumbs={[
                  { label: "Greeting Occasion Categories", href: "/admin/greeting-occasion-categories" },
                  {
                    label: "create",
                    href: `/admin/greeting-occasion-categories/Create`,
                    active: true,
                  },
                ]}
              />
              
                <GreetingOccasionCategoryCreateForm/>
              
            </main>
          );
        }



